class ProductBundleSwitch extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.addEventListener("click", this.onClick.bind(this));
  }

  async onClick(event) {
    const button = event.target.closest("[data-bundle-handle]");
    if (!button) return;

    event.preventDefault();

    const handle = button.dataset.bundleHandle;
    const productInfo = this.closest("product-info");

    if (!productInfo) return;

    const sectionId =
      productInfo.dataset.originalSection ||
      this.dataset.sectionId?.replace(/^quickadd-/, "");

    const form = productInfo.querySelector("product-form.product-form");
    const tabs = productInfo.querySelector("group-tabs");
    const gallery = productInfo.querySelector("product-media-gallery");
    const quickAddMedia = productInfo.querySelector(".product-info__medias");

    if (!form || !sectionId) return;

    const response = await fetch(`/products/${handle}?section_id=${sectionId}`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    const newProductInfo = doc.querySelector("product-info");
    const newForm = newProductInfo?.querySelector("product-form.product-form");
    const newTabs = newProductInfo?.querySelector("group-tabs");
    const newGallery = newProductInfo?.querySelector("product-media-gallery");
    const newQuickAddMedia = newProductInfo?.querySelector(
      ".product-info__medias",
    );

    if (newForm) form.replaceWith(newForm);
    if (tabs && newTabs) tabs.replaceWith(newTabs);
    if (quickAddMedia && newQuickAddMedia)
      quickAddMedia.replaceWith(newQuickAddMedia);

    /*if (gallery && newGallery) {
      requestAnimationFrame(() => {
        gallery.replaceWith(newGallery);
      });
    }*/

    if (newGallery) {
      const liveGallery = productInfo.querySelector("product-media-gallery");

      if (liveGallery) {
        liveGallery.replaceWith(newGallery);
      } else {
        console.warn("[BundleSwitch] live gallery not found", { handle });
      }
    }

    this.querySelectorAll("[data-bundle-handle]").forEach((item) => {
      const isActive = item.dataset.bundleHandle === handle;

      item.classList.toggle("is-active", isActive);
      item.classList.toggle("btn--inverse", !isActive);
    });

    this.updateQuickAddMedia(handle);
  }

  async updateQuickAddMedia(handle) {
    const mediaWrapper = this.closest("quick-add-modal")?.querySelector(
      "[data-quick-add-media]",
    );
    if (!mediaWrapper) return;

    const product = await fetch(`/products/${handle}.js`).then((res) =>
      res.json(),
    );
    const image = product.featured_image;

    if (!image) return;

    const img = mediaWrapper.querySelector("img");
    if (!img) return;

    img.src = image;
    img.srcset = "";
    img.alt = product.title;
  }
}

if (!customElements.get("product-bundle-switch")) {
  customElements.define("product-bundle-switch", ProductBundleSwitch);
}
